import { observable, action, computed } from 'mobx';
import cookie from "react-cookies"
import _ from 'lodash';
import {
  Market, Currency, MarketFilter, OddsFormat, OddsMode, 
  BetTypeGroup, Mode, EventOrder, OUTRIGHT_TYPE, TopMenuItem,
  E_SPORT_ID,
  PrefsMap} from './../common/Foundation';
import moment from 'moment';
import Utils from "../common/Utils";
import { EVENT } from '../common/events/listEvents';

export default class SportsStore {

  constructor(props) {
    this.loadPrefsOptions();
    localStorage.setItem('options', window.btoa(unescape(encodeURIComponent(JSON.stringify(this.options)))));
    window.listenEvent(EVENT.UPDATE_SPORTS_TORE, this.loadPrefsOptions);
  }

  defaultParlay = {
    sportId: 29,
    date: moment().utcOffset("GMT-04:00").format("YYYY-MM-DD")
  }
  
  // TODO 
  defaultTeaser = {
    sportId: 15,
    date: moment().utcOffset("GMT-04:00").format("YYYY-MM-DD")
  }
  // alway get current date to show
  defaultSingleEarly = {
    sportId: 29,
    date: ''
  }

  @observable options = {
    isLeagueExistedUrl: false,
    esportCodeUrl: '',
    marketIdLeagueUrl: 3,
    sportId: 29,
    leagueId: 0,
    eventId: 0,
    market: Market.None,
    currency: Currency.USD,
    marketFilter: MarketFilter._3Lines,
    oddsFormat: OddsFormat.Decimal,
    favourite: false,
    favouriteSportId: 0,
    favouriteEventIds: [],
    filterOptions: {selectedDate: Utils.generateDates(5, -240)[0].value},
    betTypeGroup: BetTypeGroup.HDP_OU,
    oddsFormatSetting: "EU,HK,MY,AM",
    oddsMode: OddsMode.Double,
    order: EventOrder.League,
    ogCache: '',
    isLive: false,
    sound: true,
    timeZoneOffset: null,
    timeFilter: 0,
    leagues: '',
    mode: Mode.NORMAL,
    moreOption: false,
    isOnlyEsport: false,
    period: -1,
    parlay: this.defaultParlay,
    teaser: this.defaultTeaser,
    sports: this.defaultSingleEarly,
    leagueIds: [],
    eSports: {
      eSportId : '',
      eSportCode: '',
      eSportLeagueIds: [],
    },
    outright: {
      sportId: 29,
      outrightType: OUTRIGHT_TYPE.OUTRIGHT,
      leagueIds: [],
    },
    periodsDescription: []
  };

  @observable topMenuData = {
    activeId: TopMenuItem.SPORT
  }
  
  @observable oddsPageData = {
    filters: []
  }

  @observable parlaySports = [];
  
  @observable teaserSports = [];

  @observable parlayDates = [];

  @observable teaserDates = [];

  @observable earlyDates = [];

  @observable goingBack = false;

  @observable  periodsDescription = [];

  
  @observable displayPeriod = {};

  @observable isDisplayOddsDelayBanner = true;

  @observable isHasDynamicParameter = false;

  @observable previousOddsFormat = '';

  @action updateHasDynamicParameter(isHasDynamicParameter) {
    this.isHasDynamicParameter = isHasDynamicParameter;
  }

  @action updateIsDisplayOddsDelayBanner() {
    this.isDisplayOddsDelayBanner = !this.isDisplayOddsDelayBanner;
  }

  @action updateGoingBack(value) {
    this.goingBack = value;
  }

  @action updateIsLeagueExistedUrl(value) {
    this.isLeagueExistedUrl = value;
  }

  @action updateMarketIdLeagueUrl(value) {
    this.marketIdLeagueUrl = value;
  }

  @action updateEsportCodeUrl(value) {
    this.esportCodeUrl = value;
  }

  updateTopMenuData(newData) {
    this.topMenuData = newData
  }

  @action setOddsPageFilter(values) {
    this.oddsPageData.filters = values
  }

  @action updateOddsPageFilter(value, isSelected) {
    let filters = this.oddsPageData.filters.toJS()
    if (isSelected) {
      if (filters && filters.indexOf(value) == -1) {
        filters.push(value)
      }
    } else {
      filters = filters.filter(ft => ft != value)
    }

    this.oddsPageData.filters = filters
  }

  @computed get getMarket() {
    return this.options.market;
  }

  @action updateOptions(options) {
    if (typeof options !== 'object') {
      return;
    }
    Object.assign(this.options, options);
    localStorage.setItem('options', window.btoa(unescape(encodeURIComponent(JSON.stringify(this.options)))));
  }

  @action updateOption(name, value) {
      if (value !== null && value !== '' && typeof value !== 'object' && value === this.options[name]) {
          return;
      }
      this.options[name] = value;
      localStorage.setItem('options', window.btoa(unescape(encodeURIComponent(JSON.stringify(this.options)))));
  }
  
  @action setTeaserSports(teaserSports) {
    this.teaserSports = teaserSports;
  }

  @action setParlaySports(parlaySports) {
    this.parlaySports = parlaySports;
  }

  @action setParlayDates(parlayDates) {
    this.parlayDates = parlayDates;
  }

  @action setEarlyDates(earlyDates) {
    this.earlyDates = earlyDates;
  }

  @action setTeaserDates(teaserDates) {
    this.teaserDates = teaserDates;
  }

  @action updatePeriodDesc(value) {
    this.periodsDescription = value;
  }

  @action updateDisplayPeriod(newData) {
    this.displayPeriod = newData;
  }

  @action updatePreviousOddsFormat(value) {
    this.previousOddsFormat = value;
  }

  @computed get getPeriodsDescription() {
    return this.periodsDescription;
  }

  @computed get getPreviousOddsFormat() {
    return this.previousOddsFormat;
  }
  loadPrefsOptions = () => {
    const options = {};
    options.ogCache = cookie.load('_og') || '';
    const __prefs = _.isEmpty(cookie.load('__prefs')) ? '' : Utils.decodeBase64(cookie.load('__prefs'));
    const __prefsJSON = _.isEmpty(__prefs) ? {} : Utils.convertStringToJSON(__prefs);

    // Update options by __prefs of user
    if (!_.isEmpty(__prefsJSON)) {
      options.timeZoneOffset = __prefsJSON[PrefsMap.timeZoneOffset] === null ? moment().utcOffset() : __prefsJSON[PrefsMap.timeZoneOffset];

      // Update DateTZ.defaultTZOffset follow timezone set in Preferences
      if (typeof(options.timeZoneOffset) !== 'undefined' && options.timeZoneOffset != null) {
        window.DateTZ.defaultTZOffset = options.timeZoneOffset;
      }
      options.oddsFormat = __prefsJSON[PrefsMap.oddsFormat];
      options.oddsMode = __prefsJSON[PrefsMap.oddsMode];
      options.market = __prefsJSON[PrefsMap.market] === 0 ? Market.Today : Market.All;
      options.betTypeGroup = __prefsJSON[PrefsMap.market] === 0 ? BetTypeGroup.HDP_OU : (__prefsJSON[PrefsMap.market] === 1 ? BetTypeGroup.ML_1X2 : BetTypeGroup.TEAM_TOTAL);
      options.order = Utils.convertEventSorting(__prefsJSON[PrefsMap.order]);
      options.sportsSorting = __prefsJSON[PrefsMap.sportsSorting] && ("," + __prefsJSON[PrefsMap.sportsSorting] + ",");
      options.enableDefaultStake = __prefsJSON[PrefsMap.enableDefaultStake];
      options.defaultStake = __prefsJSON[PrefsMap.defaultStake];
      options.acceptBetterOdds = __prefsJSON[PrefsMap.acceptBetterOdds];
      options.updateBetslipOdds = __prefsJSON[PrefsMap.updateBetslipOdds];
      options.marketFilter = Utils.castToMarketFilter(__prefsJSON[PrefsMap.marketFilter]) || 5;
      options.liveScoreNotify = __prefsJSON.length >= 12 ? __prefsJSON[PrefsMap.liveScoreNotify] : 0;
      options.timeZoneId = __prefsJSON[PrefsMap.timeZoneId] || moment.tz.guess();
      
      options.oddsFormat = _.isUndefined(OddsFormat[cookie.load('oddsFormat')]) ? options.oddsFormat : OddsFormat[cookie.load('oddsFormat')] ;
    } else {
      const perfs = localStorage.getItem('perfs');
      const oldPrefs = _.isEmpty(perfs) ? {} : Utils.convertStringToJSON(atob(perfs));
  
      // Update options by storage
      options.sound = _.isNil(oldPrefs.sound) ? true : oldPrefs.sound;
      options.favourite = oldPrefs.favourite || this.options.favourite;
      options.favouriteEventIds = oldPrefs.favouriteEventIds || [];
      options.favouriteSportId = oldPrefs.favouriteSportId || 0;
      options.timeFilter = oldPrefs.timeFilter || 0;
      options.oddsFormat = oldPrefs.oddsFormat == null ? OddsFormat.Decimal : oldPrefs.oddsFormat;
    }
    this.previousOddsFormat = options.oddsFormat;
    Object.assign(this.options, options);
  }

  @computed get getOddFormat() {
    return this.options.oddsFormat;
  }

  @computed get isParlay() {
    return this.options.mode === Mode.PARLAY || this.options.mode === Mode.PARLAY_MARKET;
  }

  @computed get isTeaser() {
    return (this.options.mode === Mode.TEASER || this.options.mode === Mode.TEASER_MARKET);
  }

  @computed get isOutright() {
    return (this.options.mode === Mode.OUTRIGHT || this.options.mode === Mode.OUTRIGHT_MARKET);
  }

  @computed get isEsport() {
    const sportId = this.isOutright ? this.options.outright.sportId : this.isParlay ? this.options.parlay.sportId : this.options.sportId;
    return sportId == E_SPORT_ID;
  }

  @computed get getSelectedLeagues() {
    let selectedLeagues = [];
    if (this.isOutright) {
      selectedLeagues = _.get(this.options, 'outright.leagueIds', []);
    } else {
      selectedLeagues = this.isEsport ? _.get(this.options , 'eSports.eSportLeagueIds', []) : _.get(this.options, 'leagueIds', []);
    }

    return selectedLeagues;
  }

  @computed get getSelectedDate() {
    const { market, parlay, teaser, sports } = this.options;

    let date = '';
    if (this.isParlay) {
      //support for live Parlay
      date = !this.isEsport && market === Market.Today ? this.defaultParlay.date : market === Market.Live ? date = '' : parlay.date;
    } else if (this.isTeaser) { // TODO
      date = !this.isEsport && (market === Market.Live || market === Market.Today) ? this.defaultTeaser.date : teaser.date;
    } else {
      date =!this.isEsport && market === Market.Today ? this.defaultSingleEarly.date : market === Market.Live ? date = '' : sports.date;
    }

    return date;
  }
}



// WEBPACK FOOTER //
// ./src/app/stores/SportsStore.js